import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=e5c4a454&scoped=true&"
import script from "./TreeMenu.vue?vue&type=script&lang=js&"
export * from "./TreeMenu.vue?vue&type=script&lang=js&"
import style0 from "./TreeMenu.vue?vue&type=style&index=0&id=e5c4a454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c4a454",
  null
  
)

export default component.exports